import { apiUrl } from "config/envConfig";
import httpService from "services/httpService";

const BASE = `${apiUrl}/payment-mgmt/admin/cashoutrule`;

// Normalize cash out rule object (support capitalized backend fields)
const normalizeCashOutRule = (r) => {
  if (!r || typeof r !== 'object') return r;
  return {
    id: r.id ?? r.Id ?? null,
    minAmount: (r.minAmount ?? r.MinAmount) != null ? Number(r.minAmount ?? r.MinAmount) : null,
    maxAmount: (r.maxAmount ?? r.MaxAmount) != null ? Number(r.maxAmount ?? r.MaxAmount) : null,
    cutoffDays: (r.cutoffDays ?? r.CutoffDays) != null ? Number(r.cutoffDays ?? r.CutoffDays) : null,
    raw: r,
  };
};

export const getCashOutRule = async () => {
  try {
    // Ocelot maps this upstream as a POST route in the gateway
    const response = await httpService.get(`${BASE}`);
    // Normalize wrapper responses: support `data` or capitalized `Data` wrapper
    const raw = response?.data?.data || response?.data?.Data || response?.data || null;
    return normalizeCashOutRule(raw) || null;
  } catch (err) {
    console.error("Failed to fetch cash out rule", err);
    return null;
  }
};

export const updateCashOutRule = async (dto) => {
  try {
    const response = await httpService.post(`${BASE}/update`, dto);
    const raw = response?.data?.data || response?.data?.Data || response?.data || null;
    return normalizeCashOutRule(raw) || response.data;
  } catch (err) {
    console.error("Failed to update cash out rule", err);
    throw err;
  }
};
